module.exports = __webpack_public_path__ + "img/dep_iceicesandicecream@3x.ae10fe2c.png";